import { cloneElement, Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { getActiveNotice, getNotices } from '../redux/selectors/notices';
import {
  hideFlashNotice as hideFlashNoticeAction,
  loadNextNotice as loadNextNoticeAction,
} from '../redux/actions/notices';

const DEFAULT_NOTICE_DURATION = 5000;

class FlashNoticesContainer extends Component {
  constructor(props) {
    super(props);

    this.timeouts = [];
    this.state = {
      fadeOutNotice: false,
    };
  }

  componentDidMount() {
    const { notices, activeNotice, loadNextNotice } = this.props;
    // MM: we need to load the next notice here as well in the case that a
    // notice was fired before the component mounted.
    if (!activeNotice && notices.length) {
      loadNextNotice();
    }
  }

  componentDidUpdate(prevProps) {
    const { notices, activeNotice } = this.props;
    const { loadNextNotice, activeNotice: currentNotice, hideFlashNotice } = prevProps;

    if (!activeNotice && notices.length) {
      loadNextNotice();
    }

    if (!currentNotice && activeNotice) {
      const { noticeDuration = DEFAULT_NOTICE_DURATION } = activeNotice;

      this.timeouts.push(
        setTimeout(() => {
          hideFlashNotice();
          this.setState({
            fadeOutNotice: false,
          });
        }, noticeDuration),
        setTimeout(() => {
          this.setState({
            fadeOutNotice: true,
          });
        }, Math.max(noticeDuration - 1000, 0)),
      );
    }
  }

  componentWillUnmount() {
    this.timeouts.forEach(clearTimeout);
  }

  render() {
    const { children, activeNotice, hideFlashNotice } = this.props;
    const { fadeOutNotice } = this.state;

    return cloneElement(children, {
      notice: activeNotice,
      hideFlashNotice,
      fadeOutNotice,
    });
  }
}

FlashNoticesContainer.propTypes = {
  // props
  children: PropTypes.element.isRequired,
  // state
  notices: PropTypes.array,
  activeNotice: PropTypes.object,
  // actions
  hideFlashNotice: PropTypes.func,
  loadNextNotice: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    notices: getNotices(state),
    activeNotice: getActiveNotice(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      hideFlashNotice: hideFlashNoticeAction,
      loadNextNotice: loadNextNoticeAction,
    },
    dispatch,
  );
}

// eslint-disable-next-line
export default connect(mapStateToProps, mapDispatchToProps)(FlashNoticesContainer);
